import { format, parseISO } from "date-fns";

export const formatDatetime = (isoString: string) => {
  return format(parseISO(isoString), "MMM d yyyy, h:mm a");
};
